import React from 'react';
import style from './ModeDisplayBar.module.scss';

const { REACT_APP_MODE: mode = '' } = process.env;

const ModeDisplayBar = () => {
  return <>{mode ? <div className={style.ModeDisplayBar}>{mode}</div> : ''}</>;
};

export default ModeDisplayBar;
